import script from "./giftCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./giftCard.vue?vue&type=script&setup=true&lang=ts"

import "./giftCard.vue?vue&type=style&index=0&id=0fada7b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fada7b4"]])

export default __exports__